import { AppConfigService } from '@foundation/app/config';
import { LayoutService } from '@foundation/app/layout';
import { UserLanguageSyncService } from '@foundation/users/state';
import { FloatingChatComponent } from '@foundation/conversations/ui'; // Added import
import { PlaylistBarComponent } from '@foundation/media/play/ui';
// import { RealtimeService } from '@foundation/realtime';
// import { DOCUMENT } from '@angular/common'; // Updated import
import { ApplicationRef, ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { UserSessionsService, UsersRepository } from '@foundation/users/state';
import { environment } from '../environments/environment';

@Component({
	standalone: true,
	imports: [RouterModule, PlaylistBarComponent, FloatingChatComponent],
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
	title = environment.title;
	layoutService = inject(LayoutService);
	applicationRef = inject(ApplicationRef);
	// realtimeService = inject(RealtimeService);
	appConfigService = inject(AppConfigService);
	userSessionsService = inject(UserSessionsService);
	userLanguageSync = inject(UserLanguageSyncService);

	usersRepository = inject(UsersRepository);

	constructor() {
		// Sync user theme preferences
		effect(() => {
			const user = this.usersRepository.currentProfile();
			if (user && user.config.theme) {
				if (user.config.theme.light) {
					this.layoutService.setLightThemePref(user.config.theme.light);
				}
				if (user.config.theme.dark) {
					this.layoutService.setDarkThemePref(user.config.theme.dark);
				}
				if (user.config.theme.mode) {
					this.layoutService.setMode(user.config.theme.mode);
				}
			}
		});

		// this.applicationRef.isStable
		// 	.pipe(
		// 		filter((isStable) => isStable),
		// 		throttleTime(3000, undefined, { leading: true, trailing: true }),
		// 		tap((isStable) => {
		// 			if (isStable) {
		// 				console.log('(th) App is stable!');
		// 				checkLocalStylesheetsForMissingFonts();
		// 			} else {
		// 				console.log('(th) App is unstable!');
		// 			}
		// 		})
		// 	)
		// 	.subscribe();

		this.appConfigService.config$
			.pipe(
				takeUntilDestroyed()
				// tap((config) => {
				// 	console.log('[AppComponent] App config loaded:', config);
				// })
			)
			.subscribe();

		this.appConfigService.config$_.environment = environment;
	}
}
